import {
  parseDate
} from "./chunk-KPPABCK2.mjs";

// src/date/format.ts
var formatDate = (date, locale, options) => {
  const defaultoptions = {
    numberingSystem: "latn",
    timeZone: "Asia/Riyadh",
    hourCycle: "h24",
    hour12: true
  };
  const safeDate = typeof date === "string" ? parseDate(date) : typeof date === "number" ? date * 1e3 : date;
  return new Intl.DateTimeFormat(locale, {
    ...defaultoptions,
    ...options
  }).format(safeDate);
};
var formatMilliseconds = (ms) => {
  const totalSeconds = Math.floor(ms / 1e3);
  const totalMinutes = Math.floor(totalSeconds / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  } else {
    return `${minutes}m`;
  }
};
var formatToAmPm = (hour, minutes) => {
  hour = hour % 24;
  const amPm = hour >= 12 ? "PM" : "AM";
  const formattedHour = hour % 12 || 12;
  return `${String(formattedHour).padStart(2, "0")}${minutes !== void 0 ? `:${String(minutes).padStart(2, "0")}` : ""} ${amPm}`;
};

export {
  formatDate,
  formatMilliseconds,
  formatToAmPm
};
//# sourceMappingURL=chunk-UCXBRCNX.mjs.map